import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CreatePartnerInput, Partner, PartnerLog } from '@nx/domain';

const partnersSlice = createSlice({
  name: 'partners',
  initialState: {
    items: [] as Partner[],
    current: null as Partner | null,
    logs: [] as PartnerLog[],
    loading: false,
    saving: false,
    error: null as string | null,
  },
  reducers: {
    partnersWatchRequested(_state, _action: PayloadAction<string>) {},
    partnersLoaded(state, action: PayloadAction<Partner[]>) {
      state.items = action.payload;
      state.loading = false;
    },
    partnerLoadRequested(state, _action: PayloadAction<{ eventId: string; partnerId: string }>) {
      state.loading = true;
    },
    partnerLoaded(state, action: PayloadAction<Partner | null>) {
      state.current = action.payload;
      state.loading = false;
    },
    partnerLogsWatchRequested(
      _state,
      _action: PayloadAction<{ eventId: string; partnerId: string }>,
    ) {},
    partnerLogsLoaded(state, action: PayloadAction<PartnerLog[]>) {
      state.logs = action.payload;
    },
    partnerCreateRequested(
      state,
      _action: PayloadAction<{ eventId: string; input: CreatePartnerInput }>,
    ) {
      state.saving = true;
    },
    partnerUpdateRequested(
      state,
      _action: PayloadAction<{
        eventId: string;
        partnerId: string;
        input: Partial<CreatePartnerInput>;
      }>,
    ) {
      state.saving = true;
    },
    partnerLogCreateRequested(
      _state,
      _action: PayloadAction<{ eventId: string; partnerId: string; content: string }>,
    ) {},
    partnerLogoReorderRequested(
      _state,
      _action: PayloadAction<{ eventId: string; orderedIds: string[] }>,
    ) {},
    partnersSaveSucceeded(state) {
      state.saving = false;
    },
    partnersFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const {
  partnersWatchRequested,
  partnersLoaded,
  partnerLoadRequested,
  partnerLoaded,
  partnerLogsWatchRequested,
  partnerLogsLoaded,
  partnerCreateRequested,
  partnerUpdateRequested,
  partnerLogCreateRequested,
  partnerLogoReorderRequested,
  partnersSaveSucceeded,
  partnersFailed,
} = partnersSlice.actions;

export default partnersSlice.reducer;
